/**
 * Vuex module for available extensions.
 */
import API from '@/api'
import events from 'Store/events'
import debug from 'debug'

const dbg = debug('store:action:availableExtensions:')

const actions = {
  load: function ({ commit }, extensionToCheck) {
    dbg('Init available extensions')
    return API.getAvailableExtensions(extensionToCheck).then(({ data }) => {
      commit('ADD', data)
    }).catch(err => {
      dbg(err)
      dbg(err?.response)
      events.pubError('Failed to load available extensions')
    }).finally(() => {
      events.unmask()
    })
  }
}

const mutations = {
  ADD (state, data) {
    state.list = data
  }
}

const state = {
  list: []
}

const getters = {
  list: state => state.list
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
